module.exports = __webpack_public_path__ + "static/svc-img-2-849776d3e2341dce3053e01197608641.jpeg";